import { Injectable } from '@angular/core';

import { Actions, ofType, createEffect } from '@ngrx/effects';
import { of } from 'rxjs';
import { map, switchMap, catchError } from 'rxjs/operators';

import * as UserActions from '@app/auth/store/actions/user.actions';

import { AuthService } from '@app/auth/services';

import { Router } from '@angular/router';
import { UserService } from '@app/auth/services';
import { ToastService } from '@app/shared/services/toast.service';
import { TranslateService } from '@ngx-translate/core';
import { NEW_PERSONAL_URL, ROUTES } from 'src/utils/constants';

@Injectable()
export class UserEffects {
  getUser$ = createEffect(() =>
    this.actions$.pipe(
      ofType<UserActions.GetCurrentUser>(
        UserActions.UserActionTypes.GET_CURRENT_USER
      ),
      switchMap((action) => {
        return this._UserService.getCurrentUser().pipe(
          map((resp) => {
            this._AuthService.updateExpiresInToken();

            return new UserActions.GetCurrentUserSuccess(resp);
          }),
          catchError((error) => {
            this._ToastService.addError(error);
            return of(new UserActions.GetCurrentUserError(error));
          })
        );
      })
    )
  );

  updateUser$ = createEffect(() =>
    this.actions$.pipe(
      ofType<UserActions.UpdateUser>(UserActions.UserActionTypes.UPDATE),
      switchMap(({ data, isPersonal }) => {
        return isPersonal
          ? this._UserService.updatePersonalData(data).pipe(
              map((resp) => {
                this._ToastService.addSuccess(
                  this.translate.instant('MEETINGS.CHANGES_SAVED')
                );
                return new UserActions.UpdatePersonalDataSuccess(data);
              }),
              catchError((error) => {
                this._ToastService.addError(error);
                return of(new UserActions.UpdatePersonalDataError(error));
              })
            )
          : this._UserService.update(data).pipe(
              map((resp) => {
                this._ToastService.addSuccess(
                  this.translate.instant('MEETINGS.CHANGES_SAVED')
                );
                return new UserActions.UpdateUserSuccess(data);
              }),
              catchError((error) => {
                this._ToastService.addError(error);
                return of(new UserActions.UpdateUserError(error));
              })
            );
      })
    )
  );

  updateUserCredentials$ = createEffect(() =>
    this.actions$.pipe(
      ofType<UserActions.UpdateUserCredentials>(
        UserActions.UserActionTypes.UPDATE_CREDENTIALS
      ),
      switchMap((action) => {
        return this._UserService.updateCredentials(action.payload).pipe(
          map((resp) => {
            return new UserActions.UpdateUserCredentialsSuccess(action.payload);
          }),
          catchError((error) => {
            this._ToastService.addError(error);
            return of(new UserActions.UpdateUserCredentialsError(error));
          })
        );
      })
    )
  );

  constructor(
    private actions$: Actions,
    private _UserService: UserService,
    private _AuthService: AuthService,
    private router: Router,
    private _ToastService: ToastService,
    private translate: TranslateService
  ) {}
}
